import React from 'react'
// Styled Components
import { Container } from './Announcement.styles'

const Announcement = () => {
    return (
        <Container>
                Super Deal! Free Shipping on Orders Over $50
        </Container>
    )
}

export default Announcement
